import { render, staticRenderFns } from "./Help-Center.vue?vue&type=template&id=502e0aca&"
import script from "./Help-Center.vue?vue&type=script&lang=js&"
export * from "./Help-Center.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports